type Props = {
    label: string;
};

export default function ActionButton({ label }: Props) {
    return (
        <button className="rounded-md bg-[#ff7a00] px-5 py-3 text-sm font-black uppercase tracking-wide text-white shadow-[0_12px_32px_rgba(255,122,0,0.28)] transition hover:translate-y-[-1px] hover:opacity-95">
            {label}
        </button>
    );
}